import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const WaitlistActionModal = ({
  modal,
  toggle,
  onAdmit,
  onDelete,
  loading,
  userName,
}) => {
  return (
    <Modal isOpen={modal} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Manage User Access</ModalHeader>
      <ModalBody>
        {userName && (
          <p className="mb-3 text-center">
            <strong>{userName}</strong>
          </p>
        )}
        <p className="text-center mb-2">
          Select an action for this user:
        </p>
        <p className="text-center text-muted text-sm mb-0">
          <i className="ni ni-bell-55 mr-1"></i>
          This action cannot be undone
        </p>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button
          color="primary"
          size="sm"
          onClick={onAdmit}
          disabled={loading}
        >
          Admit Access
        </Button>
        <Button
          color="danger"
          size="sm"
          onClick={onDelete}
          disabled={loading}
        >
          Delete Account
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default WaitlistActionModal;
